import { type DevicesTypes } from '@frontend/api-devices';
import { useTranslation } from '@frontend/i18n';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { SurfaceHeader } from '@frontend/surface-header';
import { theme } from '@frontend/theme';
import { Chip, Table, Text, TextLink, Tray, useModalControl } from '@frontend/design-system';

type Props = {
  modalControls: ReturnType<typeof useModalControl>;
  deviceId: string | undefined;
  callGroups: DevicesTypes.ListDeviceSipProfileTypes['callGroups'];
  deviceName: string | undefined;
  locationIds: string[];
};
export const CallGroupSideModal = ({ modalControls, deviceId, deviceName, callGroups, locationIds }: Props) => {
  const { t } = useTranslation('phone', { keyPrefix: 'devices' });
  const { navigate } = useSettingsNavigate();

  return (
    <>
      <Tray mountTarget='[data-settings-modal-content]' width='medium' {...modalControls.modalProps}>
        <SurfaceHeader.Root noBorder css={{ margin: theme.spacing(-4, -4, 0, -4), width: 'calc(100% + 64px)' }}>
          <SurfaceHeader.Row>
            <SurfaceHeader.Title>{t('Call Group Assignments')}</SurfaceHeader.Title>
            <SurfaceHeader.Actions>
              <SurfaceHeader.Icon
                iconName='x'
                onClick={() => {
                  modalControls.closeModal();
                }}
              />
            </SurfaceHeader.Actions>
          </SurfaceHeader.Row>
        </SurfaceHeader.Root>
        <Text color='light'>{t('{{name}}', { name: deviceName })}</Text>
        <Tray.Body>
          <TextLink
            onClick={() =>
              navigate({ to: '/phone/devices/:id', params: { id: deviceId ?? '' }, search: { id: deviceId ?? '' } })
            }
            weight='bold'
            css={{ marginBottom: theme.spacing(2) }}
          >
            {t('Edit Call Group Assignments')}
          </TextLink>

          <Table
            data={callGroups ?? []}
            colConfig={[
              {
                Header: t('Locations'),
                accessor: (group) => group.location?.name,
                cellRenderer: (name) => (name ? <Chip.SingleChip>{name}</Chip.SingleChip> : ''),
                id: 'location-name',
                sortType: 'caseInsensitive',
                omit: locationIds.length === 1,
              },
              {
                Header: t('Call Group Name'),
                accessor: (group) => group.name,
                id: 'callGroupName',
                disableSortBy: true,
              },
            ]}
          />
        </Tray.Body>
      </Tray>
    </>
  );
};
